import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { BrowserRouter } from 'react-router-dom';

const reactRoot = ReactDOM.createRoot(document.getElementById('root'));
reactRoot.render(
    <BrowserRouter>
        <App />
    </BrowserRouter>
)